import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';

import {
    Theme, Accordion, AccordionDetails, AccordionSummary,
    Typography, Container, Box,
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AlmeCloseConfig } from './AlmeCloseConfig';
import { AlmeCloseIconConfig } from '../AlmeCloseIcon/AlmeCloseIconConfig';
import AlmeCloseIconConfigTool from '../AlmeCloseIcon/AlmeCloseIconConfigTool';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
        },
    }),
);

interface AlmeCloseConfigToolProps {
    almeConfig: AlmeCloseConfig;
    onConfigChange: (almeConfig: AlmeCloseConfig) => void;
}

const AlmeCloseConfigTool: React.FC<AlmeCloseConfigToolProps> = (props: AlmeCloseConfigToolProps) => {
    const classes = useStyles();

    const onCloseIconConfigChance = (closeIconConfig: AlmeCloseIconConfig): void => {
        const closeConfig: AlmeCloseConfig = {
            close: {
                ...props.almeConfig.close,
                closeIcon: {
                    ...closeIconConfig.closeIcon,
                },
            },
        };
        props.onConfigChange(closeConfig);
    };

    return (
        <Box className={classes.root}>
            <Accordion>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel-alme-close-config-tool-content"
                    id="panel-alme-close-config-tool-header"
                >
                    <Typography variant='h6'>Alme Close Config Tools</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Container>
                        <AlmeCloseIconConfigTool almeConfig={props.almeConfig.close} onConfigChange={onCloseIconConfigChance} />
                    </Container>
                </AccordionDetails>
            </Accordion>
        </Box >
    );
};

export default AlmeCloseConfigTool;